
import { cn } from "@/lib/utils";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

export interface BaseCardProps {
  id: string;
  title: string;
  linkPath?: string;
  icon?: ReactNode;
  className?: string;
  children?: ReactNode;
  headerActions?: ReactNode;
  footerContent?: ReactNode;
}

export const BaseCard = ({ 
  id,
  title,
  linkPath,
  icon,
  className,
  children,
  headerActions,
  footerContent
}: BaseCardProps) => {
  const header = (
    <div className="flex justify-between items-center">
      <div className="flex items-center gap-2">
        {icon && <span className="text-gray-400">{icon}</span>}
        <h3 className="text-lg font-semibold text-gray-900">
          {linkPath ? (
            <Link to={linkPath} className="hover:underline">
              {title}
            </Link>
          ) : (
            title
          )}
        </h3>
      </div>
      {headerActions}
    </div>
  );
  
  return (
    <Card className={cn("h-full transition-all hover:shadow-md", className)}>
      <CardHeader className="pb-2">
        {header}
      </CardHeader>
      
      <CardContent className="pt-2">
        {children}
      </CardContent>
      
      {footerContent && (
        <div className="px-6 pb-4">
          {footerContent}
        </div>
      )}
    </Card>
  );
};
